<script setup lang="ts">
type Props = {
  title: string;
  hint?: string;
};

const model = defineModel<boolean>({ default: false });
const { title, hint = "" } = defineProps<Props>();

function toggle(): void {
  model.value = !model.value;
}
</script>

<template>
  <div
    class="flex cursor-pointer items-center justify-between gap-4 rounded-lg p-2.5 transition-all hover:bg-gray-100 dark:hover:bg-kekkle-dark-dark"
    @click="toggle"
  >
    <div class="flex-1">
      <p class="font-bold text-kekkle-dark dark:text-slate-200">
        {{ title }}
      </p>
      <p v-if="hint" class="mt-0.5 text-xs text-gray-500 dark:text-slate-400">
        {{ hint }}
      </p>
    </div>

    <!-- Custom Kekkle Toggle Switch -->
    <div
      class="relative inline-flex h-7 w-12 shrink-0 items-center rounded-full border-2 border-kekkle-dark p-0.5 transition-all duration-200"
      :class="
        model
          ? 'bg-kekkle-yellow shadow-yellow-hard-sm'
          : 'bg-gray-300 dark:bg-gray-600'
      "
    >
      <span
        class="h-5 w-5 transform rounded-full border-2 border-kekkle-dark bg-white transition-transform duration-200"
        :class="model ? 'translate-x-[18px]' : 'translate-x-0'"
      />
    </div>
  </div>
</template>
